import React from 'react';
import { Trans } from '@lingui/macro';

import { Checkbox, CheckboxProps } from 'antd';
import { ButtonProps, Button } from 'components/AntD';

export interface ConfirmConditionsProps {
  onChanged: CheckboxProps['onChange'];
  onSubmit: ButtonProps['onClick'];
  onBack(): void;
  isChecked?: boolean;
  inviteeEmail: string;
  companyName: string;
  firstName: string;
}

const ConfirmConditions = ({
  isChecked,
  onChanged,
  inviteeEmail,
  companyName,
  firstName,
  onSubmit = () => void 0,
  onBack = () => void 0,
}: ConfirmConditionsProps): JSX.Element => (
  <div className="confirm-sending-email tw-flex tw-flex-col tw-gap-4">
    <div className="checkbox-wrapper tw-text-sm tw-bg-gray-100 tw-rounded-sm tw-p-6 tw-text-gray-700">
      <Checkbox id="confirm-conditions" checked={isChecked} onChange={onChanged}>
        <Trans>
          I give Searchlight permission to share my reference data with {firstName}. I acknowledge
          that Searchlight will contact {inviteeEmail} to verify that they are a recruiter or hiring
          manager at {companyName}.
        </Trans>
      </Checkbox>
    </div>
    <div className="tw-flex tw-flex-row tw-gap-4">
      <Button onClick={onBack} variant="contained" color="default" block>
        <Trans>Back</Trans>
      </Button>
      <Button onClick={onSubmit} disabled={!isChecked} variant="contained" color="primary" block>
        <Trans>Submit</Trans>
      </Button>
    </div>
  </div>
);

export default ConfirmConditions;
